<template>
  <div ref="layout" class="layout" :class="{ collapsed: !sideBarIsOpen  }" >

    <Navbar class="app-bar" />

    <div ref="main" class="main">
      <Sidebar v-if="!isMobile" @collapseExpand="collapseExpand" :isOpen="sideBarIsOpen" class="sidebar" :class="{ collapsed: !sideBarIsOpen }" />

      <div class="content">
        <router-view />
      </div>
    </div>

  </div>
</template>

<script>
import Sidebar from "@/components/app/Sidebar";
import Navbar from "@/components/app/Navbar";
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: "main-layout",
  computed: {
    ...mapGetters('ui', ['isMobile', 'isDark', 'sideBarIsOpen']),
  },
  components: {
    Navbar,
    Sidebar,
  },
  methods: {
    ...mapMutations('ui', ['SET_SIDE_BAR_IS_OPEN']),
    
    collapseExpand() {
      this.SET_SIDE_BAR_IS_OPEN();
    },

    updateHeight() {
      if (this.isMobile && this.$refs.layout && this.$refs.main) {
        this.$refs.layout.style.height = `${window.innerHeight}px`;
        this.$refs.main.style.height = `${window.innerHeight}px`;
      } else if (this.$refs.layout && this.$refs.main) {
        this.$refs.layout.style.height = "100vh";
        this.$refs.main.style.height = "100vh";
      }
    },
  },

  watch: {
    isMobile() {
      this.updateHeight();
    }
  }
};
</script>

<style scope>

.layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  transition: grid-template-columns 0.3s ease;
  background-color: var(--primary-background-light);
  color: var(--text-light)!important;
}

.my-app-dark .layout {
  background-color: var(--primary-background-dark);
  color: var(--text-dark)!important;
}

.app-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: var(--header-height);
  background-color: var(--primary-background-light);
  z-index: 100; 
}

.main {
  margin-top: var(--header-height); 
  height: 100vh;
  display: flex;
  overflow-y: hidden;
}

.sidebar {
  padding: 16px !important;
  max-width: var(--side-bar-width);
  transition: width 0.3s ease;
  border-right: 1px solid var(--border-light);
  overflow-y: auto;
}

.my-app-dark .sidebar {
  border-right: 1px solid var(--border-dark);
}

.sidebar.collapsed {
  width: var(--side-bar-collapsed-width);
}

.content {
  width: 100%;
  padding: 16px;
  height: auto;
  display: flex;
  overflow-y: scroll;
}

@media (max-width: 768px) {
  .main {
    flex-direction: column;
  }

  .sidebar {
    display: none;
  }

  .content {
    width: 100%;
  }
}

</style>
